// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"Spinner_spinnerWrapper__Xu_O3","spinner":"Spinner_spinner__1FBUt","spin":"Spinner_spin__Ogagk","spinnerText":"Spinner_spinnerText__29cgY"};